import * as React from 'react';

import Container from '@mui/material/Container';
import Grid from '@mui/material/Unstable_Grid2';

import { useLoaderData, useNavigate } from 'react-router-dom';

import { useForm, FormProvider } from 'react-hook-form';
import Form from '../components/form/Form';
import FormTextField from '../components/form/FormTextField';
import FormButton from '../components/form/FormButton';

import Header from '../components/Header';
import GoBack from '../components/GoBack';

import { newLocation, getLocation, saveLocation } from '../models/locations';
import { useAuth } from '../context/AuthProvider';
import { useMessage } from '../context/MessageProvider';
import { useConnectivity } from '../context/ConnectivityProvider';

export async function loader({ params }) {
  const location = params?.locationId
    ? await getLocation(params.locationId)
    : newLocation();
  return { location: location || newLocation() };
}

export default function LocationFormPage({ title = 'Location', ...props }) {
  const navigate = useNavigate();
  const { location } = useLoaderData();
  const { facilityId } = useAuth();
  const { isOnline } = useConnectivity();
  const { setSuccess, setError } = useMessage();
  const [working, setWorking] = React.useState(false);

  const methods = useForm({ defaultValues: { ...location } });

  const onSubmit = async (data) => {
    try {
      setWorking(true);
      const payload = { ...location, ...data };
      await saveLocation(payload, facilityId, isOnline);
      setSuccess('Location saved');
      navigate('/locations');
    } catch (error) {
      console.error(error);
      setError(error);
    } finally {
      setWorking(false);
    }
  };

  return (
    <Container component="main" maxWidth="sm">
      <GoBack onClick={() => navigate('/locations')} />
      <Header label={title} />

      <FormProvider {...methods}>
        <Form onSubmit={methods.handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid xs={12}>
              <FormTextField name="name" label="Name" required />
            </Grid>

            <Grid xs={12}>
              <FormButton onSubmit={methods.handleSubmit(onSubmit)} fullWidth working={working}>
                Save
              </FormButton>
            </Grid>
          </Grid>
        </Form>
      </FormProvider>
    </Container>
  );
}
